import React from "react";
import type MuxPlayerElement from "@mux/mux-player";
type PlayableRef = React.RefObject<HTMLVideoElement | MuxPlayerElement | null>;
type ContextProps = {
  isWaiting: boolean;
  setIsWaiting: (value: boolean) => void;
  videoRef: PlayableRef | null;
  setVideoRef: (ref: PlayableRef | null) => void;
  play: () => void;
  hasPlayedOnce: boolean;
  setHasPlayedOnce: (value: boolean) => void;
};
const Context = React.createContext<ContextProps | undefined>(undefined);
export function VideoProvider({
  children
}: {
  children: React.ReactNode;
}) {
  const [isWaiting, setIsWaiting] = React.useState(false);
  const [videoRef, setVideoRef] = React.useState<PlayableRef | null>(null);
  const [hasPlayedOnce, setHasPlayedOnce] = React.useState(false);
  const play = React.useCallback(() => {
    const el = videoRef?.current;
    if (!el) return;
    if ("play" in el && typeof el.play === "function") {
      void el.play();
    }
    setHasPlayedOnce(true);
  }, [videoRef]);
  return <Context.Provider value={{
    isWaiting,
    setIsWaiting,
    videoRef,
    setVideoRef,
    play,
    hasPlayedOnce,
    setHasPlayedOnce
  }}>
      {children}
    </Context.Provider>;
}
export function useVideo() {
  const context = React.useContext(Context);
  if (!context) {
    throw new Error("useVideo must be used within a VideoProvider");
  }
  return context;
}